/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSignupSurvey } from '../../models/api-response-signup-survey';

export interface GetOwnSignupSurvey$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getOwnSignupSurvey(http: HttpClient, rootUrl: string, params: GetOwnSignupSurvey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSignupSurvey>> {
  const rb = new RequestBuilder(rootUrl, getOwnSignupSurvey.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSignupSurvey>;
    })
  );
}

getOwnSignupSurvey.PATH = '/v1/api/ui/company/signup-survey';
